import createMigration from 'redux-persist-migrate';

// Doc --> https://github.com/wildlifela/redux-persist-migrate

const manifestMigration = {
  1: state => ({ ...state }),
  // Few migration examples to add/remove reducer/property
  // 2: state => ({ ...state, staleReducer: undefined }),
  // 3: state => ({ ...state, appState: { ...state.appState, staleKey: undefined } }),
  // 4: state => ({ ...state, appState: { ...state.appState, newKey: {} } }),
  // 5: state => ({ ...state, appState: { ...state.appState, newKey: undefined } }),
};

// reducerKey is the key of the reducer we want to store the state version in
// Here after migrations run `state.appState.version` will equal the last version of the manifest
const reducerKey = 'appState';
const migration = createMigration(manifestMigration, reducerKey);

export default migration;



// WEBPACK FOOTER //
// ./book/src/commons/offline/persistStoreMigration.js